import utils from 'services/utils'

const menuItems = state => state.menu.items
const sidebarOpened = state => state.app.sidebar.opened
const toggleWithoutAnimation = state => state.app.sidebar.withoutAnimation
const config = state => state.app.config
const palette = state => state.app.config.palette
const isLoading = state => state.app.isLoading
const isLoadingLight = state => state.app.isLoadingLight
const profile = state => state.app.profile
const csfrToken = state => state.app.csfrToken
const breadcrumbs = state => {
  return (keyword) => utils.findInNestedByName(state.menu.items, keyword)
}

export {
  menuItems,
  toggleWithoutAnimation,
  sidebarOpened,
  config,
  palette,
  isLoading,
  isLoadingLight,
  breadcrumbs,
  profile,
  csfrToken
}



// WEBPACK FOOTER //
// ./src/store/getters.js